import { Button, ButtonProps } from '@mui/material'
import { forwardRef } from 'react';

interface FlowentiButtonProps extends ButtonProps {
    title?: string;
    component?: any;
    to?: string
}

const FlowentiButton = forwardRef<HTMLButtonElement, FlowentiButtonProps>(
    ({ title, onClick, variant, color, sx, children, component, to, ...props }: FlowentiButtonProps, ref) => {
        return (
            <Button
                to={to}
                onClick={onClick}
                variant={variant as any}
                component={component}
                color="secondary"
                sx={{
                    border: "1px solid rgb(84, 189, 193)",
                    fontWeight: "bold",
                    borderRadius: 5,
                    boxShadow: "none",
                    px: 3,
                    py: 2,
                    ...sx
                }}
                {...props}
            >
                {title || children}
            </Button>
        )
    }
)

export default FlowentiButton